module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "material-container"
  }, [_c('Tabs', {
    attrs: {
      "value": _vm.appName
    },
    on: {
      "on-click": _vm.currentTabChanged
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "启明瞳服务号",
      "name": "qmtfwh"
    }
  }, [(_vm.appName === 'qmtfwh') ? _c('Card', [_c('Tables', {
    ref: "tables",
    attrs: {
      "searchable": "",
      "editable": "",
      "border": "",
      "appName": _vm.appName,
      "currPage": _vm.currPage,
      "pageSize": _vm.pageSize,
      "pageTotal": _vm.pageTotal,
      "columns": _vm.columns,
      "loading": _vm.loading1,
      "albumList": _vm.albumList,
      "height": 600
    },
    model: {
      value: (_vm.tableData),
      callback: function($$v) {
        _vm.tableData = $$v
      },
      expression: "tableData"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "无障碍科技",
      "name": "ACCESSIBILITY_TECHNOLOGY"
    }
  }, [(_vm.appName === 'ACCESSIBILITY_TECHNOLOGY') ? _c('Card', [_c('Tables', {
    ref: "tables",
    attrs: {
      "searchable": "",
      "editable": "",
      "border": "",
      "appName": _vm.appName,
      "currPage": _vm.currPage,
      "pageSize": _vm.pageSize,
      "pageTotal": _vm.pageTotal,
      "columns": _vm.columns,
      "loading": _vm.loading1,
      "albumList": _vm.albumList,
      "height": 600
    },
    model: {
      value: (_vm.tableData),
      callback: function($$v) {
        _vm.tableData = $$v
      },
      expression: "tableData"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "我能帮帮忙服务号",
      "name": "I_Can_Help"
    }
  }, [(_vm.appName === 'I_Can_Help') ? _c('Card', [_c('Tables', {
    ref: "tables",
    attrs: {
      "searchable": "",
      "editable": "",
      "border": "",
      "appName": _vm.appName,
      "currPage": _vm.currPage,
      "pageSize": _vm.pageSize,
      "pageTotal": _vm.pageTotal,
      "columns": _vm.columns,
      "loading": _vm.loading1,
      "albumList": _vm.albumList,
      "height": 600
    },
    model: {
      value: (_vm.tableData),
      callback: function($$v) {
        _vm.tableData = $$v
      },
      expression: "tableData"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e73e17ec","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/components/material-blocks/weChatMaterial.vue
// module id = IE5C
// module chunks = 0